import { Listbox } from '@headlessui/react';
import { ReactComponent as CloseIcon } from 'assets/icons/add_circle_outline.svg';
import { ReactComponent as DropdownIcon } from 'assets/icons/chevron-down.svg';
import useWorkingHourLabel from 'hooks/useWorkingHourLabel';
import { ControllerRenderProps } from 'react-hook-form';
import { TimeFrameFormValues } from '../AdvancedSetting';

const BlockoutType = ({
  field,
}: {
  field: ControllerRenderProps<TimeFrameFormValues, 'syncedWorkingHourLabelId'>;
}) => {
  const { isLoading, data } = useWorkingHourLabel();

  const workingHourLabels = data?.data || [];

  const options = workingHourLabels.map((item: any) => ({
    label: item.name,
    value: item.id,
  }));

  if (workingHourLabels.length === 0 || isLoading) {
    return null;
  }

  const selectedOption =
    options.find((item) => item.value === field.value) || null;

  return (
    <>
      <span className="text-16 leading-[2.4rem] font-bold" id="blockout-type">
        Blockout Type
      </span>
      <Listbox {...field}>
        {({ open }) => {
          return (
            <div className="relative text-14 leading-[2.1rem] mt-0.8 mb-2">
              <Listbox.Button
                className={`relative w-full h-[4.8rem] pl-1.6 cursor-pointer rounded-[1rem] bg-white border-[0.5px] border-light-grey text-left shadow-primary hover:border-magenta hover:shadow-input-active outline-none ${
                  open ? 'border-magenta shadow-input-active' : ''
                }`}
              >
                <span
                  className={`block pr-3 ${
                    selectedOption?.label
                      ? 'text-darkest-grey'
                      : 'text-mid-grey'
                  }`}
                >
                  {selectedOption?.label || 'Select Blockout Type'}
                </span>
                {field.value && (
                  <span
                    role="button"
                    tabIndex={0}
                    className="absolute inset-y-0 right-3 flex items-center pr-2 cursor-pointer"
                    onClick={(e) => {
                      e.stopPropagation();
                      field.onChange(null);
                    }}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.stopPropagation();
                        field.onChange(null);
                      }
                    }}
                  >
                    <CloseIcon className="w-1.4 h-1.4 transform rotate-45 all-child:all-child:fill-grey" />
                  </span>
                )}
                <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                  <DropdownIcon className="w-1.4 h-1.4" />
                </span>
              </Listbox.Button>
              <Listbox.Options className="absolute mt-0.5 max-h-16 scrollbar w-full overflow-auto rounded-[0.8rem] bg-white py-1.5 text-base shadow-primary flex flex-col gap-y-1.5 z-10">
                {options?.map((option: any) => (
                  <Listbox.Option
                    key={option.value}
                    className="relative cursor-default select-none pl-1.6"
                    value={option.value}
                  >
                    <span
                      className={`block truncate cursor-pointer hover:text-magenta ${
                        selectedOption?.value === option.value
                          ? 'text-magenta'
                          : ''
                      }`}
                    >
                      {option.label}
                    </span>
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </div>
          );
        }}
      </Listbox>
    </>
  );
};

export default BlockoutType;
